









































































































































import { defineComponent, reactive, toRefs, PropType, computed, watch, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../commons/common"
import http from "../plugins/http";
import AlertArea from "../components/AlertArea.vue";
import DrawArea from "../components/DrawArea.vue";
import { Examinee, ReviewText, ReviewImage, SheetActivity, ReviewTypeEnum, AutoReviewTextTemplate, AutoReviewImageTemplate, SheetField, AutoReviewTargetTypeEnum } from "../modules/teacher/SaitenList"
// @ts-ignore
import { longClickDirective } from 'vue-long-click'
const longClickInstance = longClickDirective({delay: 500, interval: 0})
// @ts-ignore
import VueDragResize from "vue-drag-resize";
import VSwatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.css"
import TextDirectionToggle from "../components/TextDirectionToggle.vue";
import heic2any from "heic2any";

export interface Data {
  inputScale: number
  selectedPageIdx: number
  headerHeight: number
  footerHeight: number
  selectedReview: any
  copiedReview: any
  errors: string[]
  drawMode: number
  fontSize: number
  lineHeight: number
  keyCode: string
  touchLength: number
  thickness: number
  drawColor: string
  textColor: string
}

export default defineComponent({
  directives: {
    longclick: longClickInstance
  },
  components: {
    "vue-drag-resize": VueDragResize,
    "alert-area": AlertArea,
    "draw-area": DrawArea,
    "v-swatches": VSwatches,
    "text-direction-toggle": TextDirectionToggle,
  },
  props: {
    examinee: {
      type: Examinee as PropType<Examinee>,
      required: true
    },
    autoReviewTextTemplates: {
      type: Array as PropType<AutoReviewTextTemplate[]>,
      required: true
    },
    autoReviewImageTemplates: {
      type: Array as PropType<AutoReviewImageTemplate[]>,
      required: true
    },
    sheetFields: {
      type: Array as PropType<SheetField[]>,
      required: true
    },
    modalHeight: {
      type: Number as PropType<number>,
      required: true
    },
    imageWidth: {
      type: Number as PropType<number>,
      required: true
    },
    imageHeight: {
      type: Number as PropType<number>,
      required: true
    },
    isReviewOverlay: {
      type: Boolean as PropType<boolean>,
      required: true
    },
  },
  setup (props, context) {

    const DrawModeEnum = Common.DrawModeEnum;

    /************************************************************
     * Data
     ************************************************************/

    const state = reactive<Data>({
      inputScale: 50,
      selectedPageIdx: 0,
      headerHeight: 46,
      footerHeight: 35,
      selectedReview: null,
      copiedReview: null,
      errors: [],
      drawMode: Common.DrawModeEnum.None,
      fontSize: 48,
      lineHeight: 0,
      keyCode: null,
      touchLength: 0,
      thickness: 2,
      drawColor: "#FF0000",
      textColor: "#FF0000",
    });

    /************************************************************
     * 画像の親DivのCSSスタイル
     ************************************************************/

    const imageWrapStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${props.imageWidth * scale.value}px`;
      style["height"] = `${props.imageHeight * scale.value}px`;
      return style;
    });

    /************************************************************
     * 画像領域の高さ
     ************************************************************/

    const imageAreaHeight = computed((): number => {
      return props.modalHeight - state.headerHeight - state.footerHeight;
    });

    /************************************************************
     * スライダーの倍率を画像倍率に変換
     ************************************************************/

    const scale = computed((): number => {
      return Number(state.inputScale / 100);
    });

    /******************************
     * マウスホイール拡大縮小
     ******************************/

    const imageAreaMousewheel = (e: WheelEvent) => {
      if(state.keyCode == "Control" || e.ctrlKey){
        e.preventDefault();
        const newScale = state.inputScale - (e.deltaY / 30);
        if(newScale >= 10 && newScale <= 200){
          state.inputScale = newScale;
        }
      }
    }

    /************************************************************
     * 画像の親DivのCSSスタイル
     ************************************************************/

    const imageStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${props.imageWidth * scale.value}px`;
      style["height"] = `${props.imageHeight * scale.value}px`;
      return style;
    });

    /************************************************************
     * 表示対象生徒切り替え
     ************************************************************/

    const changeExaminee = async (addCount: number) => {
      state.selectedReview = null;
      props.examinee.sheetActivities.forEach(SheetActivity => {
        SheetActivity.reviewTexts.forEach(reviewText => {
          reviewText.is_active = false;
        });
      });
      context.emit("change-review-examinee", props.examinee, addCount);
    }

    /************************************************************
     * ページ切り替え
     ************************************************************/

    const changePage = (idx: number) => {
      state.selectedReview = null;
      props.examinee.sheetActivities.forEach(SheetActivity => {
        SheetActivity.reviewTexts.forEach(reviewText => {
          reviewText.is_active = false;
        });
      });
      state.selectedPageIdx = idx;
    }

    
    /************************************************************
     * 更新
     ************************************************************/

    const update = async (isShowConfirm: boolean) => {

      let reviewTexts: ReviewText[] = []
      props.examinee.sheetActivities.forEach(x => {
        reviewTexts = reviewTexts.concat(x.reviewTexts);
      });

      let reviewImages: ReviewImage[] = []
      props.examinee.sheetActivities.forEach(x => {
        reviewImages = reviewImages.concat(x.reviewImages);
      });

      const isReviewed = reviewTexts.length > 0 || reviewImages.length > 0 || props.examinee.sheetActivities.filter(x => x.is_canvas_drawed).length > 0;

      if(isShowConfirm && !window.confirm(`${props.examinee.student_code} ${props.examinee.student_name} ${props.examinee.times}回目の講評コメントを更新します。よろしいですか？`)){
        return;
      }

      const param = {
        review_texts: reviewTexts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0),
        review_images: reviewImages,
        base64_canvases: props.examinee.sheetActivities.map(x => {
          return {
            sheet_activity_id: x.id,
            base64_canvas: x.base64Canvas,
          };
        }),
        sheet_id: props.examinee.sheet_id,
        examinee_id: props.examinee.id,
        is_reviewed: isReviewed,
      }

      context.emit("update-review", param);
   }

   /************************************************************
     * ショートカットキー＋マウスダウンによる解答モード変更
     * DrawAreaコンポーネントから呼ばれる
     ************************************************************/

    const changeDrawModeFromChild = (drawMode: number) => {
      state.drawMode = drawMode;
      state.selectedReview = null;
    }

    /************************************************************
     * canvas編集後のbase64文字列保存
     * DrawAreaコンポーネントから呼ばれる
     ************************************************************/

    const updateCanvas = (base64Canvas: string, bitCnt: number) => {
      props.examinee.sheetActivities[state.selectedPageIdx].base64Canvas = base64Canvas;
      setIsCanvasDrawed(props.examinee.sheetActivities[state.selectedPageIdx], bitCnt);
    }

    /************************************************************
     * is_canvas_drawed設定
     ************************************************************/

    const setIsCanvasDrawed = async (sheetActivity: SheetActivity, bitCnt: number) => {
      sheetActivity.is_canvas_drawed = bitCnt > 1000;
    }

    /************************************************************
     * テキストスタンプ追加
     ************************************************************/

    const addTextStamp = (param: any) => {
      const size = Common.getTextSize({text: "", fontSize: state.fontSize, lineHeight: state.lineHeight, direction: context.root.$store.state.textDirection});
      const reviewText = new ReviewText();
      reviewText.sheet_activity_id = props.examinee.sheetActivities[state.selectedPageIdx].id;
      reviewText.idx = props.examinee.sheetActivities[state.selectedPageIdx].idx++;
      reviewText.font_size = state.fontSize;
      reviewText.line_height = 0;
      reviewText.color = state.textColor;
      reviewText.x = param.point.x;
      reviewText.y = param.point.y;
      reviewText.width = size.width;
      reviewText.height = size.height;
      reviewText.direction = context.root.$store.state.textDirection;
      reviewText.base64_text = Common.createBase64Text(reviewText);
      reviewText.review_type = ReviewTypeEnum.Text;
      props.examinee.sheetActivities[state.selectedPageIdx].reviewTexts.push(reviewText);
    }

    /************************************************************
    * 画像テンプレート追加
    ************************************************************/
    const addImageStamp = (event: any) => {

      const files = event.target.files;

      if(files.length > 1){
        alert("複数ファイルは選択できません。");
        return;
      }

      // 拡張子チェック
      const extentions = ["jpg", "jpeg", "heic", "png"];
      const file_work = files[0].name.split('.');
      const extention = file_work[file_work.length - 1].toLowerCase();
      if(!extentions.includes(extention)) {
        alert(`選択可能なファイルは[${extentions}]です。`);
        return;
      }

      if(extention == "heic"){
        heic2any({
          blob: files[0],
          toType: 'image/jpeg',
          quality: 1.0
        })
        .then((conversionResult: any) => {
          const img = new Image();
          img.onload = () => {
            imageLoaded(img, extention);
          };
          img.src = URL.createObjectURL(conversionResult);
        })
        .catch(function(error) {
          console.error(error);
        });
      }else{
        const reader  = new FileReader();
        reader.onload = (e) => {        
          const img = new Image();
          img.onload = () => {
            imageLoaded(img, extention);
          };
          img.src = e.target?.result as string;
        };
        reader.readAsDataURL(files[0]);
      }

      event.target.value = "";
      };

      /************************************************************
      * 画像ファイルロード後
      ************************************************************/

      const imageLoaded = (img: HTMLImageElement, extention: string) => {
      const imageType = extention == "png" ? "image/png" : "image/jpeg"
      let width = img.width;
      let height = img.height;

      let scale = 1;
      const scaleW = (props.imageWidth - 20) / img.width;
      const scaleH = (props.imageHeight - 20) / img.height;

      if(scaleW > scaleH){
        // scale = scaleH > 1 ? 1 : scaleH;
        scale = scaleH;
      }else{
        // scale = scaleW > 1 ? 1 : scaleW;
        scale = scaleW
      }

      width *= scale;
      height *= scale;

      // 画像をcanvasに描画した後にbase64文字列に変換
      const canvas = document.createElement("canvas") as HTMLCanvasElement;
      const ctx = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;
      ctx?.drawImage(img, 0, 0, width, height);
      const base64 = canvas.toDataURL(imageType, 1.0).replace(`data:${imageType};base64,`, "");

      const reviewImage = new ReviewImage();
      reviewImage.sheet_activity_id = props.examinee.sheetActivities[state.selectedPageIdx].id;
      reviewImage.idx = props.examinee.sheetActivities[state.selectedPageIdx].idx++;
      reviewImage.x = 10;
      reviewImage.y = 10;
      reviewImage.width = width * 0.5;
      reviewImage.height = height * 0.5;
      reviewImage.base64_image = base64;
      reviewImage.review_type = ReviewTypeEnum.Image;
      props.examinee.sheetActivities[state.selectedPageIdx].reviewImages.push(reviewImage);
    }

    /************************************************************
     * テキストスタンプ削除 切り出しコンポーネントから呼ばれる
     ************************************************************/

    const deleteTextStamp = (textStamp: any) => {
      const idx = props.examinee.sheetActivities[state.selectedPageIdx].reviewTexts.indexOf(textStamp);
      props.examinee.sheetActivities[state.selectedPageIdx].reviewTexts.splice(idx, 1);
    }

    /************************************************************
     * 画像スタンプ削除 切り出しコンポーネントから呼ばれる
     ************************************************************/

     const deleteImageStamp = (imageStamp: any) => {
      const idx = props.examinee.sheetActivities[state.selectedPageIdx].reviewImages.indexOf(imageStamp);
      props.examinee.sheetActivities[state.selectedPageIdx].reviewImages.splice(idx, 1);
    }

    /************************************************************
     * 選択中の講評スタンプ切り替え
     ************************************************************/

    const changeSelectedReview = (selectedReview: any) => {
      state.selectedReview = selectedReview;
      if(selectedReview && selectedReview.review_type == ReviewTypeEnum.Text){
        state.textColor = selectedReview.color;
        state.fontSize = selectedReview.font_size;
        state.lineHeight = selectedReview.line_height;
      }
    }

    /************************************************************
     * keydown
     ************************************************************/

    const keyDown = (e:KeyboardEvent) => {
      if(e.key == "c" && e.ctrlKey && state.selectedReview != null){
        // 現在選択中のテキストをコピー
        if(state.selectedReview.review_type == ReviewTypeEnum.Text){
          const reviewText = new ReviewText();
          reviewText.text = state.selectedReview.text;
          reviewText.font_size = state.selectedReview.font_size;
          reviewText.line_height = state.selectedReview.line_height;
          reviewText.color = state.selectedReview.color;
          reviewText.x = state.selectedReview.x;
          reviewText.y = state.selectedReview.y;
          reviewText.width = state.selectedReview.width;
          reviewText.height = state.selectedReview.height;
          reviewText.direction = state.selectedReview.direction;
          reviewText.base64_text = state.selectedReview.base64_text;
          reviewText.review_type = ReviewTypeEnum.Text;
          state.copiedReview = reviewText;
        }else if(state.selectedReview.review_type == ReviewTypeEnum.Image){
          const reviewImage = new ReviewImage();
          reviewImage.x = state.selectedReview.x;
          reviewImage.y = state.selectedReview.y;
          reviewImage.width = state.selectedReview.width;
          reviewImage.height = state.selectedReview.height;
          reviewImage.base64_image = state.selectedReview.base64_image;
          reviewImage.review_type = ReviewTypeEnum.Image;
          state.copiedReview = reviewImage;
        }
        
      }else if(e.key == "v" && e.ctrlKey && state.copiedReview != null){
        // コピーしたテキストをペースト
        if(state.copiedReview.review_type == ReviewTypeEnum.Text){
          const reviewText = new ReviewText();
          reviewText.sheet_activity_id = props.examinee.sheetActivities[state.selectedPageIdx].id;
          reviewText.idx = props.examinee.sheetActivities[state.selectedPageIdx].idx++;
          reviewText.text = state.copiedReview.text;
          reviewText.font_size = state.copiedReview.font_size;
          reviewText.line_height = state.copiedReview.line_height;
          reviewText.color = state.copiedReview.color;
          reviewText.x = state.copiedReview.x;
          reviewText.y = state.copiedReview.y;
          reviewText.width = state.copiedReview.width;
          reviewText.height = state.copiedReview.height;
          reviewText.direction = state.copiedReview.direction;
          reviewText.base64_text = Common.createBase64Text(reviewText);
          reviewText.review_type = ReviewTypeEnum.Text;
          props.examinee.sheetActivities[state.selectedPageIdx].reviewTexts.push(reviewText);
        }else if(state.copiedReview.review_type == ReviewTypeEnum.Image){
          const reviewImage = new ReviewImage();
          reviewImage.sheet_activity_id = props.examinee.sheetActivities[state.selectedPageIdx].id;
          reviewImage.idx = props.examinee.sheetActivities[state.selectedPageIdx].idx++;
          reviewImage.x = state.copiedReview.x;
          reviewImage.y = state.copiedReview.y;
          reviewImage.width = state.copiedReview.width;
          reviewImage.height = state.copiedReview.height;
          reviewImage.base64_image = state.copiedReview.base64_image;
          reviewImage.review_type = ReviewTypeEnum.Image;
          props.examinee.sheetActivities[state.selectedPageIdx].reviewImages.push(reviewImage);
        }
        
      }else{
        state.keyCode = e.key;
      }
    }

    /************************************************************
     * keyup
     ************************************************************/

    const keyUp = (e: KeyboardEvent) => {
      state.keyCode = "";

      // メモのtextareaがフォーカスされている場合は処理しない
      if(document.activeElement.nodeName.toLowerCase() == "textarea"){
        return;
      }

      if(e.key == "Backspace" && state.selectedReview != null){

        if(state.selectedReview.review_type == ReviewTypeEnum.Text){
          const idx = props.examinee.sheetActivities[state.selectedPageIdx].reviewTexts.indexOf(state.selectedReview);
          props.examinee.sheetActivities[state.selectedPageIdx].reviewTexts.splice(idx, 1);
        }else if(state.selectedReview.review_type == ReviewTypeEnum.Image){
          const idx = props.examinee.sheetActivities[state.selectedPageIdx].reviewImages.indexOf(state.selectedReview);
          props.examinee.sheetActivities[state.selectedPageIdx].reviewImages.splice(idx, 1);
        }
        
        state.selectedReview = null;
      }
    }

    /************************************************************
     * 出力済みテキストスタンプ文言編集後イベント
     ************************************************************/

    const changeText = () => {
      const size = Common.getTextSize({text: state.selectedReview.text, fontSize: state.selectedReview.font_size, lineHeight: state.selectedReview.line_height, direction: state.selectedReview.direction});
      
      if(state.selectedReview.direction == Common.DirectionEnum.Vertical){
        let diffW = size.width - state.selectedReview.width;
        state.selectedReview.x -= diffW;
      }

      state.selectedReview.width = size.width;
      state.selectedReview.height = size.height;
      state.selectedReview.base64_text = Common.createBase64Text(state.selectedReview);
    }

    /************************************************************
     * 出力済みテキストスタンプのフォントサイズ・行間・カラー変更後イベント
     ************************************************************/

    const textFormatChanged = () => {
      state.selectedReview.font_size = state.fontSize;
      state.selectedReview.line_height = state.lineHeight;
      state.selectedReview.color = state.textColor;
      const size = Common.getTextSize({text: state.selectedReview.text, fontSize: state.fontSize, lineHeight: state.lineHeight, direction: state.selectedReview.direction});
      
      if(state.selectedReview.direction == Common.DirectionEnum.Vertical){
        let diffW = size.width - state.selectedReview.width;
        state.selectedReview.x -= diffW;
      }
      
      state.selectedReview.width = size.width;
      state.selectedReview.height = size.height;
      state.selectedReview.base64_text = Common.createBase64Text(state.selectedReview);
    }

    /************************************************************
     * モード切り替え
     ************************************************************/
    
    const changeDrawMode = (drawMode: number) => {
      
      const current = document.activeElement;
      if(current != null){
        (current as HTMLElement).blur();
      }
      
      state.selectedReview = null;
      if(state.drawMode == drawMode){
        state.drawMode = DrawModeEnum.None;
      }else{
        state.drawMode = drawMode;
      }
    }

    /************************************************************
     * 講評対象生徒切り替え監視
     ************************************************************/

    watch(() => props.examinee, (examiee: Examinee) => {
      if(examiee){
        for(const sheetActivity of examiee.sheetActivities){
          if(sheetActivity.base64Canvas){
            const canvasImage = new Image();
            canvasImage.src = `data:image/png;base64,${sheetActivity.base64Canvas}`;
            canvasImage.onload = async () => {
              const canvas = document.createElement("canvas") as HTMLCanvasElement;
              canvas.width = props.imageWidth;
              canvas.height = props.imageHeight;
              const ctx = canvas.getContext("2d");
              ctx.drawImage(canvasImage, 0, 0);
              const bitCnt = ctx.getImageData(0, 0, props.imageWidth, props.imageHeight).data.filter(x => x > 0).length;
              setIsCanvasDrawed(sheetActivity, bitCnt);
            };
          }
        }
      }
    });

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      const imageWrap = document.getElementById("image-wrap");
      const imageWrapWidth = imageWrap.clientWidth - 20;
      const imageWrapHeight = imageWrap.clientHeight - 20;
      const perW = imageWrapWidth / props.imageWidth;
      const perH = imageWrapHeight / props.imageHeight;
      state.inputScale = perW > perH ? perH * 100 : perW * 100;
      window.addEventListener("keydown", keyDown);
      window.addEventListener("keyup", keyUp);
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("keydown", keyDown);
      window.removeEventListener("keyup", keyUp);
    });

    /******************************
     * 自動講評差替え
     ******************************/

    const setAutoReview = () => {
      if(!window.confirm(`現在の得点から自動講評を差替えて保存します。\n出力済みの講評は削除されます。\nよろしいですか？`)){
        return;
      }

      // 設問ごとの採点結果から大問別得点を集計
      const part1ScoreHash: {[key: string]: number} = {};
      const sheetFieldHash: {[key: number]: SheetField} = {};
      props.sheetFields.forEach(sheetField => {
        sheetFieldHash[sheetField.id] = sheetField;
      });

      props.examinee.fieldActivities.forEach(fieldActivity => {
        if(fieldActivity.score == null){
          return;
        }
        const sheetField = sheetFieldHash[fieldActivity.sheet_field_id];
        if(!sheetField || sheetField.part1 == null){
          return;
        }
        if(part1ScoreHash[sheetField.part1] == null){
          part1ScoreHash[sheetField.part1] = 0;
        }
        part1ScoreHash[sheetField.part1] += fieldActivity.score;
      });

      // 合計点講評と大問講評をそれぞれ判定し、条件一致したテンプレートを全件抽出
      const autoReviewTextTemplates = props.autoReviewTextTemplates.filter(x => {
        if(x.target_type == AutoReviewTargetTypeEnum.Part1){
          if(x.part1 == null || part1ScoreHash[x.part1] == null){
            return false;
          }
          return x.score_from <= part1ScoreHash[x.part1] && x.score_to >= part1ScoreHash[x.part1];
        }
        return x.score_from <= props.examinee.score && x.score_to >= props.examinee.score;
      });
      const autoReviewImageTemplates = props.autoReviewImageTemplates.filter(x => {
        if(x.target_type == AutoReviewTargetTypeEnum.Part1){
          if(x.part1 == null || part1ScoreHash[x.part1] == null){
            return false;
          }
          return x.score_from <= part1ScoreHash[x.part1] && x.score_to >= part1ScoreHash[x.part1];
        }
        return x.score_from <= props.examinee.score && x.score_to >= props.examinee.score;
      });

      if(autoReviewTextTemplates.length == 0 && autoReviewImageTemplates.length == 0){
        alert("得点範囲に該当する自動講評はありませんでした。");
        return;
      }

      // 登録済みの講評を削除
      props.examinee.sheetActivities.forEach(sheetActivity => {
        sheetActivity.reviewTexts = [];
        sheetActivity.reviewImages = [];
      });

      autoReviewTextTemplates.forEach(autoReviewTextTemplate => {
        // テンプレートに設定されたページの答案へ講評を登録
        const reviewTargetSheetActivity = props.examinee.sheetActivities.find(x => x.page == autoReviewTextTemplate.page);
        if(!reviewTargetSheetActivity){
          return;
        }
        const reviewText = new ReviewText();
        reviewText.sheet_activity_id = reviewTargetSheetActivity.id;
        reviewText.idx = reviewTargetSheetActivity.idx++;
        reviewText.text = autoReviewTextTemplate.text;
        reviewText.font_size = autoReviewTextTemplate.font_size;
        reviewText.line_height = autoReviewTextTemplate.line_height;
        reviewText.color = autoReviewTextTemplate.color;
        reviewText.x = autoReviewTextTemplate.x;
        reviewText.y = autoReviewTextTemplate.y;
        reviewText.width = autoReviewTextTemplate.width;
        reviewText.height = autoReviewTextTemplate.height;
        reviewText.direction = autoReviewTextTemplate.direction;
        reviewText.base64_text = Common.createBase64Text(reviewText);
        reviewText.review_type = ReviewTypeEnum.Text;
        reviewTargetSheetActivity.reviewTexts.push(reviewText);
      });

      autoReviewImageTemplates.forEach(autoReviewImageTemplate => {
        // テンプレートに設定されたページの答案へ講評を登録
        const reviewTargetSheetActivity = props.examinee.sheetActivities.find(x => x.page == autoReviewImageTemplate.page);
        if(!reviewTargetSheetActivity){
          return;
        }
        const reviewImage = new ReviewImage();
        reviewImage.sheet_activity_id = reviewTargetSheetActivity.id;
        reviewImage.idx = reviewTargetSheetActivity.idx++;
        reviewImage.x = autoReviewImageTemplate.x;
        reviewImage.y = autoReviewImageTemplate.y;
        reviewImage.width = autoReviewImageTemplate.width;
        reviewImage.height = autoReviewImageTemplate.height;
        reviewImage.base64_image = autoReviewImageTemplate.base64_image;
        reviewImage.review_type = ReviewTypeEnum.Image;
        reviewTargetSheetActivity.reviewImages.push(reviewImage);
      });

      update(false);
    }

    return {
      ...toRefs(state),
      DrawModeEnum,
      ReviewTypeEnum,
      AutoReviewTargetTypeEnum,
      scale,
      imageAreaHeight,
      imageStyle,
      changeExaminee,
      update,
      changePage,
      imageWrapStyle,
      changeDrawModeFromChild,
      updateCanvas,
      addTextStamp,
      addImageStamp,
      deleteTextStamp,
      deleteImageStamp,
      changeSelectedReview,
      changeText,
      textFormatChanged,
      changeDrawMode,
      imageAreaMousewheel,
      setAutoReview,
    }
  }
});
